import React, {
	Component
} from 'react';
import { B64Image } from './B64Image';

export class Checkbox extends Component {
	render(){
		return <B64Image
			className="sa_checkbox"
			style={this.props.style}
			onClick={this.props.onClick}
			alt="checked"
			src={"/assets/profile/profile_checkbox_"+(this.props.toggle ? 'on' : 'off')+".png"}
		/>
	}
}
